module.exports = __webpack_public_path__ + "static/media/dashboard.3bdc4ae1.svg";